import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { filterUndefined, trackByRef } from 'src/app/lego-utils';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { Roles } from 'src/app/models/domain';
import { AdminService, SessionService } from 'src/app/state';

@Component({
  selector: 'em-role-selection',
  styleUrls: ['./role-selection.component.less'],
  templateUrl: './role-selection.component.html',
  standalone: false,
})
export class RoleSelectionComponent {
  public name$ = this.sessionService.userName$;
  public isAdmin$ = this.sessionService.userShortName$.pipe(
    filterUndefined(),
    switchMap((userId) => this.adminService.get(userId)),
    map(() => true),
    catchError(() => of(false))
  );

  public readonly trackByRef = trackByRef;
  public listOfRoles = Object.values(Roles);

  public constructor(
    private readonly adminService: AdminService,
    private readonly sessionService: SessionService,
    private readonly router: Router
  ) {}

  public selectRole(role: string) {
    this.sessionService.setCurrentRole(role);
    void this.router.navigate(['/data/design']);
  }
}
